"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    // creates classes from opa1 to opa10
    return {
        opa1: { opacity: 0.1 },
        opa2: { opacity: 0.2 },
        opa3: { opacity: 0.3 },
        opa4: { opacity: 0.4 },
        opa5: { opacity: 0.5 },
        opa6: { opacity: 0.6 },
        opa7: { opacity: 0.7 },
        opa8: { opacity: 0.8 },
        opa9: { opacity: 0.9 }
    };
});
//# sourceMappingURL=Opacity.js.map